import React from "react";
import { GoogleLogin } from "@react-oauth/google";

interface GoogleAuthButtonProps {
  onSuccess: (response: any) => void;
  onError: () => void;
  text?: "signin_with" | "signup_with" | "continue_with" | "signin";
}

// Google Identity Services renders its native button with a hardcoded
// pill that doesn't follow our design tokens (and on the personalized
// "Sign in as <user>" variant it ignores the `theme` prop entirely,
// so it always shows white). To get a consistent look across themes,
// we always render our own button on top and layer the real GIS
// component as an opacity-0 overlay (z-index 2) — the user sees our
// styled button, clicks land on the invisible Google iframe above it,
// and the real sign-in flow still fires.
const GOOGLE_BTN_WIDTH = 280;
const GOOGLE_BTN_HEIGHT = 44;

const GoogleAuthButton: React.FC<GoogleAuthButtonProps> = ({
  onSuccess,
  onError,
  text = "continue_with",
}) => {
  const visibleLabel =
    text === "signup_with"
      ? "Sign up with Google"
      : text === "signin"
      ? "Sign in"
      : text === "signin_with"
      ? "Sign in with Google"
      : "Continue with Google";

  return (
    <div
      className="googleAuth"
      style={{ width: GOOGLE_BTN_WIDTH, height: GOOGLE_BTN_HEIGHT }}
    >
      <div className="googleAuth__visible" aria-hidden="true">
        <svg
          className="googleAuth__logo"
          viewBox="0 0 48 48"
          width="20"
          height="20"
        >
          <path
            fill="#FFC107"
            d="M43.6 20.5H42V20H24v8h11.3c-1.6 4.7-6.1 8-11.3 8-6.6 0-12-5.4-12-12s5.4-12 12-12c3.1 0 5.8 1.2 7.9 3l5.7-5.7C34.5 6.1 29.5 4 24 4 12.9 4 4 12.9 4 24s8.9 20 20 20 20-8.9 20-20c0-1.3-.1-2.4-.4-3.5z"
          />
          <path
            fill="#FF3D00"
            d="M6.3 14.7l6.6 4.8C14.7 15.1 19 12 24 12c3.1 0 5.8 1.2 7.9 3l5.7-5.7C34.5 6.1 29.5 4 24 4 16.3 4 9.7 8.3 6.3 14.7z"
          />
          <path
            fill="#4CAF50"
            d="M24 44c5.2 0 10-2 13.6-5.2l-6.3-5.3c-2 1.4-4.5 2.3-7.3 2.3-5.2 0-9.6-3.3-11.3-8l-6.5 5C9.6 39.6 16.2 44 24 44z"
          />
          <path
            fill="#1976D2"
            d="M43.6 20.5H42V20H24v8h11.3c-.8 2.3-2.3 4.3-4.3 5.7l6.3 5.3C41.4 35.2 44 30 44 24c0-1.3-.1-2.4-.4-3.5z"
          />
        </svg>
        <span>{visibleLabel}</span>
      </div>
      <div className="googleAuth__google">
        <GoogleLogin
          onSuccess={onSuccess}
          onError={onError}
          width={GOOGLE_BTN_WIDTH}
          text={text}
        />
      </div>
    </div>
  );
};

export default GoogleAuthButton;
